module.exports = __webpack_public_path__ + "img/bg-onboarding-fourth.58e67b45.svg";